export const truncate = (input: string, count: number): string =>
  input.length > count ? `${input.substring(0, count)}...` : input
